import { useMutation, useQueryClient, useQuery } from "@tanstack/react-query";
import { coamAreaApi } from "./api/coamArea";
import { qk } from "../../lib/queryKeys";

export const useCoamAreas = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async () => {
      return await coamAreaApi.fetchCoamAreas();
    },
    onSuccess: async () => {
      await qc.refetchQueries({ queryKey: qk.coamAreas() });
    },
  });
};

export const useQuickFilter = (regionId: number | null) => {
  return useQuery({
    queryKey: qk.geospatial.quickFilter(regionId),
    queryFn: () => coamAreaApi.fetchQuickFilter(regionId!),
    enabled: !!regionId,
  });
};

export const useWorkstack = (regionId: number | null) => {
  return useQuery({
    queryKey: qk.geospatial.workstack(regionId),
    queryFn: () => coamAreaApi.fetchWorkstack(regionId!),
    enabled: !!regionId,
  });
};

export const useGeospatialProjects = (params: {
  stage_gate_id?: number;
  phase_type_id?: number;
  region_id: number | null;
  phase_name?: string;
  page?: number;
  limit?: number;
}) => {
  return useQuery({
    queryKey: qk.geospatial.projects(params),
    queryFn: () =>
      coamAreaApi.fetchProjects({
        stage_gate_id: params.stage_gate_id,
        phase_type_id: params.phase_type_id,
        region_id: params.region_id!,
        phase_name: params.phase_name,
        page: params.page,
        limit: params.limit,
      }),
    enabled: !!params.region_id,
  });
};
